import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Screen } from '../../components/Screen/Screen';
import { ScreenHeader } from '../../components/ScreenHeader/ScreenHeader';
import { ProgressIndicator } from '../../components/ProgressIndicator/ProgressIndicator';
import { Button } from '../../components/Button/Button';
import { MultiSelect } from '../../components/MultiSelect/MultiSelect';
import { copy, labels, validation } from '../../constants';
import { useOnboardingStore } from '../../store/onboarding';
import type { Concern } from '../../types';

export const ConcernsScreen: React.FC = () => {
  const navigate = useNavigate();
  const { data, updateData, setStep } = useOnboardingStore();
  const [error, setError] = useState('');

  const concerns = data.concerns || [];

  const options = [
    { value: 'sleep', label: labels.concerns.sleep },
    { value: 'stress-burnout', label: labels.concerns['stress-burnout'] },
    { value: 'anxiety-panic', label: labels.concerns['anxiety-panic'] },
    { value: 'trauma', label: labels.concerns.trauma },
    { value: 'depression', label: labels.concerns.depression },
    { value: 'supporting-someone', label: labels.concerns['supporting-someone'] },
    { value: 'something-else', label: labels.concerns['something-else'] }
  ];

  const handleContinue = () => {
    if (concerns.length === 0) {
      setError(validation.concernsRequired);
      return;
    }
    
    updateData({ concerns });
    setStep(5);
    navigate('/optional-note');
  };

  const handleChange = (selected: string[]) => {
    setError('');
    updateData({ concerns: selected as Concern[] });
  };

  return (
    <Screen>
      <ProgressIndicator currentStep={4} totalSteps={8} />
      
      <ScreenHeader
        title={copy.concerns.title}
        subtitle={copy.concerns.subtitle}
      />
      
      <MultiSelect
        options={options}
        selected={concerns}
        onChange={handleChange}
        error={error}
      />
      
      <div style={{ marginTop: 'var(--spacing-lg)' }}>
        <Button
          variant="primary"
          size="large"
          fullWidth
          onClick={handleContinue}
        >
          {copy.concerns.button}
        </Button>
      </div>
    </Screen>
  );
};
